import { Link } from 'react-router-dom'
import { LanguageContext } from '../../index';
import { useContext } from 'react';
import Projects from '../../api/Projects'

const ProjectSectionS2 = (props) => {
const { language } = useContext(LanguageContext);
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    const isPolish = language === 'pl';

    return (
        <section className="apartment-section s2 text-center">
            <div className="container">
                <div className="section-title mb-75">
                    <h2>
                        {isPolish ? 'Sprawdź nasze' : 'Check our'}
                        <span className="thin">{isPolish ? 'portfolio' : 'portfolio'}</span>
                    </h2>
                    <p>
                        {isPolish
                            ? 'Zobacz jak drewno nadaje charakteru wnętrzom'
                            : 'See how wood gives character to interiors'}
                    </p>
                </div>
                <div className="apartment-carousel">
                    {[0, 3, 6, 9, 12, 15].map((start, rowIdx) => (
                        <div className="row" key={rowIdx}>
                            {Projects.slice(start, start + 3).map((project, i) => (
                                <div className="col col-lg-4 col-md-6 col-12" key={i}>
                                    <div className="apartment-item">
                                        <div className="apartment-img">
                                            <img src={project.pImg} alt="Apartment" />
                                        </div>
                                        <div className="apartment-content">
                                            <img src={project.ssIcon} alt="Icon" />
                                            <h3>
                                                <Link onClick={ClickHandler} to={`/project-single/${project.slug}`}>
                                                    {isPolish ? project.pTitle : project.pTitleEn}
                                                </Link>
                                            </h3>
                                            <span> {project.width}</span>
                                            <p>
                                                {isPolish ? project.des : project.desEn}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default ProjectSectionS2;